/**
 * Composable to store and retrieve the Matomo page view ID
 */
export function useMatomoPageViewId() {
  const matomoPageViewId = useState<string | null>("matomoPageViewId", () => null)

  const setMatomoPageViewId = (id: string | null) => {
    matomoPageViewId.value = id
  }

  const getMatomoPageViewId = () => {
    return matomoPageViewId.value
  }

  return {
    matomoPageViewId,
    setMatomoPageViewId,
    getMatomoPageViewId,
  }
}
